import { FC } from 'react';
import { Box } from '@base-app';
import { NotificationProps, NotificationVariants } from './Notification.types';
import {
  ErrorIconStyled,
  InfoIconStyled,
  NotificationStyled,
  StyledCloseButton,
  StyledExitIcon,
  SuccessIconStyled,
} from './Notification.styles';

import { useRemoveNotification } from '@/modules/notifications/store';

const NotificationIcon: FC<NotificationProps> = ({ variant }) => {
  let icon;

  switch (variant) {
    case NotificationVariants.SUCCESS:
      icon = <SuccessIconStyled />;
      break;
    case NotificationVariants.ERROR:
      icon = <ErrorIconStyled />;
      break;
    case NotificationVariants.INFO:
      icon = <InfoIconStyled />;
      break;
  }

  return <Box css={{ width: '$6' }}>{icon}</Box>;
};

const Notification: FC<NotificationProps> = (props) => {
  const { autoClose, css, title, variant, description, banner, textAlign, id: idNotification } = props;
  const removeNotification = useRemoveNotification();

  const handleCloseNotification = (id?: number): void => {
    id && removeNotification(id);
  };

  return (
    <NotificationStyled
      css={{ ...css }}
      banner={banner}
      data-testid="notification-container"
      textAlign={textAlign}
      variant={variant}
    >
      <Box css={{ padding: '$4', display: 'flex' }}>
        <NotificationIcon {...props} />
        <Box css={{ paddingLeft: '$3' }}>
          <Box
            css={{
              color: '$textPrimary',
              fontSize: '$sm',
              fontWeight: '$bold',
            }}
            data-testid="notification-title"
          >
            {title}
          </Box>
          {description != null && (
            <Box
              css={{ color: '$textPrimary', fontSize: '$sm', fontWeight: '$medium' }}
              data-testid="notification-description"
            >
              {description}
            </Box>
          )}
        </Box>
      </Box>
      {!autoClose && idNotification && (
        <StyledCloseButton
          data-testid={'notification-close-button'}
          onClick={() => handleCloseNotification(idNotification)}
        >
          <StyledExitIcon data-testid={'notification-close-button-icon'} />
        </StyledCloseButton>
      )}
    </NotificationStyled>
  );
};

Notification.defaultProps = {
  banner: false,
};

export default Notification;
